import {
  categories,
  categoryDetails,
  difficulties,
  questionTypes,
} from './quizCategories.js';
import { generalKnowledgeQuestions } from './questions/generalKnowledge.js';
import { scienceQuestions } from './questions/science.js';
import { historyQuestions } from './questions/history.js';
import { geographyQuestions } from './questions/geography.js';
import { natureAnimalsQuestions } from './questions/natureAnimals.js';
import { artsCultureQuestions } from './questions/artsCulture.js';
import { technologyQuestions } from './questions/technology.js';
import { webDevelopmentQuestions } from './questions/webDevelopment.js';

const questionGroups = [
  generalKnowledgeQuestions,
  scienceQuestions,
  historyQuestions,
  geographyQuestions,
  natureAnimalsQuestions,
  artsCultureQuestions,
  technologyQuestions,
  webDevelopmentQuestions,
];

const pointsByDifficulty = {
  Easy: 10,
  Medium: 20,
  Hard: 30,
};

const normalizeQuestion = (question) => ({
  ...question,
  tags: question.tags || [],
  points: question.points ?? pointsByDifficulty[question.difficulty],
});

export const questions = questionGroups.flat().map(normalizeQuestion);

export { categories, categoryDetails, difficulties, questionTypes };

export const matchesQuestion = (question, filters = {}) => {
  const {
    search = '',
    category = 'All',
    difficulty = 'Any',
    type = 'Any',
  } = filters;

  const categoryMatch = category === 'All' || question.category === category;
  const difficultyMatch = difficulty === 'Any' || question.difficulty === difficulty;
  const typeMatch = type === 'Any' || question.type === type;
  const query = search.trim().toLowerCase();

  const searchMatch =
    query.length === 0 ||
    [
      question.id,
      question.category,
      question.difficulty,
      question.type,
      question.question,
      ...(question.tags || []),
    ]
      .join(' ')
      .toLowerCase()
      .includes(query);

  return categoryMatch && difficultyMatch && typeMatch && searchMatch;
};
